import { useEffect, useRef, useState } from "react";
import { mensagemDeErro, respostaOk } from "../../../utils/resposta";

// Busca um relatório e devolve { dados, erro, carregando }. Refaz a consulta
// quando os filtros mudam e descarta a resposta de uma consulta que já ficou
// velha (o usuário trocou o filtro antes de a anterior voltar).
export function useRelatorio(buscar, filtros = {}, habilitado = true) {
  const [estado, setEstado] = useState({ dados: null, erro: "", carregando: habilitado });
  const contador = useRef(0);
  const chave = JSON.stringify(filtros);

  useEffect(() => {
    if (!habilitado) {
      setEstado({ dados: null, erro: "", carregando: false });
      return;
    }
    const atual = ++contador.current;
    setEstado((e) => ({ ...e, carregando: true, erro: "" }));

    buscar(filtros).then((resultado) => {
      if (atual !== contador.current) return;
      if (respostaOk(resultado)) {
        setEstado({ dados: resultado.data, erro: "", carregando: false });
      } else {
        setEstado({ dados: null, erro: mensagemDeErro(resultado), carregando: false });
      }
    });
    // `filtros` entra por `chave`; `buscar` é estável (método do model).
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [chave, habilitado]);

  return estado;
}

export const numero = (valor) => Number(valor || 0).toLocaleString("pt-BR");
